function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#section-6-icons-5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M101.159 1.58008H50.5794V22.128H101.159",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.7818 60.0625H37.9346V6.13224C37.9346 4.92493 37.455 3.76707 36.6013 2.91338C35.7476 2.05968 34.5897 1.58008 33.3824 1.58008H15.3793C13.9406 1.57966 12.5601 2.14778 11.5384 3.16069C5.16148 9.54263 1.57975 18.1956 1.58058 27.2175V60.0625H10.6533",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2897 7.90234V22.1278H8.3614C9.37187 16.7507 11.964 11.7976 15.8061 7.90234H25.2897Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1285 71.1266C28.2391 71.1266 33.1927 66.1729 33.1927 60.0623C33.1927 53.9517 28.2391 48.998 22.1285 48.998C16.0179 48.998 11.0642 53.9517 11.0642 60.0623C11.0642 66.1729 16.0179 71.1266 22.1285 71.1266Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1285 64.8049C21.1906 64.8049 20.2739 64.5268 19.4941 64.0058C18.7143 63.4848 18.1065 62.7442 17.7476 61.8777C17.3887 61.0113 17.2948 60.0579 17.4778 59.138C17.6607 58.2182 18.1123 57.3733 18.7755 56.7101C19.4387 56.047 20.2836 55.5954 21.2034 55.4124C22.1232 55.2294 23.0766 55.3233 23.9431 55.6822C24.8095 56.0411 25.5501 56.6489 26.0712 57.4287C26.5922 58.2085 26.8703 59.1253 26.8703 60.0631",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.3212 71.1266C61.4319 71.1266 66.3855 66.1729 66.3855 60.0623C66.3855 53.9517 61.4319 48.998 55.3212 48.998C49.2106 48.998 44.257 53.9517 44.257 60.0623C44.257 66.1729 49.2106 71.1266 55.3212 71.1266Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.3212 64.8049C54.3834 64.8049 53.4666 64.5268 52.6868 64.0058C51.907 63.4848 51.2993 62.7442 50.9404 61.8777C50.5815 61.0113 50.4876 60.0579 50.6705 59.138C50.8535 58.2182 51.3051 57.3733 51.9683 56.7101C52.6314 56.047 53.4763 55.5954 54.3961 55.4124C55.316 55.2294 56.2694 55.3233 57.1358 55.6822C58.0023 56.0411 58.7429 56.6489 59.2639 57.4287C59.7849 58.2085 60.0631 59.1253 60.0631 60.0631",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.4497 71.1266C83.5604 71.1266 88.514 66.1729 88.514 60.0623C88.514 53.9517 83.5604 48.998 77.4497 48.998C71.3391 48.998 66.3855 53.9517 66.3855 60.0623C66.3855 66.1729 71.3391 71.1266 77.4497 71.1266Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.4497 64.8049C76.5119 64.8049 75.5951 64.5268 74.8153 64.0058C74.0355 63.4848 73.4278 62.7442 73.0689 61.8777C72.71 61.0113 72.6161 60.0579 72.799 59.138C72.982 58.2182 73.4336 57.3733 74.0968 56.7101C74.7599 56.047 75.6048 55.5954 76.5246 55.4124C77.4445 55.2294 78.3979 55.3233 79.2644 55.6822C80.1308 56.0411 80.8714 56.6489 81.3924 57.4287C81.9135 58.2085 82.1916 59.1253 82.1916 60.0631",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.0631 22.1279L66.3855 28.4504H74.2885L80.611 22.1279H60.0631Z",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.257 60.0632H37.9346V39.5153C37.9346 38.2576 38.4341 37.0515 39.3234 36.1623C40.2127 35.273 41.4188 34.7734 42.6764 34.7734H90.0946C91.3522 34.7734 92.5583 35.273 93.4476 36.1623C94.3368 37.0515 94.8364 38.2576 94.8364 39.5153V60.0632H88.514",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4509 34.7734H12.6448C9.71041 34.7734 6.89617 35.9391 4.82122 38.0141C2.74627 40.089 1.58058 42.9033 1.58058 45.8377V47.4183",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.3867 28.4502H22.1285",
  strokeWidth: 2.10748,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "section-6-icons-5"
}, /*#__PURE__*/React.createElement("rect", {
  width: 101.159,
  height: 72.7079,
  fill: "white"
})));

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 73,
    viewBox: "0 0 102 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon-5.5f57744b.svg";
export { ForwardRef as ReactComponent };